/*
	Copyright (c) 2022 PierceGearhart
	StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (Cyperhost).
*/

// Components
import Gamehero from '../../components/heros/game.js';
import Footer from '../../components/footer.js';
import Button from '../../components/buttons/primary.js';
import WhyCyperhost from '../../components/sections/whyCyperhost.js';
import DDoSProtection from '../../components/sections/ddosProtection';
import Reviews from '../../components/sections/reviews';
// Images
import SSD from '../../assets/images/hosting/ssd.svg';
import Panel from '../../assets/images/web/panel.svg';

const Web = () => {
    return (
        <main>
            <Gamehero title="Reseller Hosting" description="Powerful and intuitive easy to use Reseller hosting. We don't overcomplicate things. It just works." />
            <section className="plans max-w-7xl mx-auto px-5 sm:px-5 lg:px-5 py-24">
                <div className="primary-gradient px-3 sm:px-3 md:px-6 lg:px-10 rounded-md pt-16 pb-24">
                    <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-16 gap-y-16 px-4 place-content-evenly">
                        <div className='plan bg-box py-12 px-10 rounded-lg'>
                            <div className='header mb-11'>
                                <h1 className='text-gray-100 font-semibold text-3xl text-center'>Starter</h1>
                            </div>
                            <div className='body mb-10'>
                                <div className='accounts flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>Hosting Accounts</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>15</h2>
                                    </div>
                                </div>
                                <div className='storage flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>Storage</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>40GB</h2>
                                    </div>
                                </div>
                                <div className='domains flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>Domains</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>Unlimited</h2>
                                    </div>
                                </div>
                                <div className='bandwidth flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>Bandwidth</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>Unlimited</h2>
                                    </div>
                                </div>
                                <div className='sql flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>SQL Databases</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>Unlimited</h2>
                                    </div>
                                </div>
                                <div className='email flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>Email Addresses</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>Unlimited</h2>
                                    </div>
                                </div>
                                <div className='subdomains flex items-center'>
                                    <div>
                                        <h1 className='text-gray-300'>Subdomains</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>Unlimited</h2>
                                    </div>
                                </div>
                            </div>
                            <div className='footer'>
                                <div className='price mb-6'>
                                    <h1 className='text-gray-100 text-3xl font-semibold text-center'>$12.00 <span className='text-gray-300 text-sm font-normal'>/month</span></h1>
                                </div>
                                <div className='add-cart flex justify-center'>
                                    <Button title="Add to Cart" link="https://client.cyperhost.com/store/reseller-hosting/reseller-starter" />
                                </div>
                            </div>
                        </div>
                        <div className='plan bg-box py-12 px-10 rounded-lg'>
                            <div className='header mb-11'>
                                <h1 className='text-gray-100 font-semibold text-3xl text-center'>Standard</h1>
                            </div>
                            <div className='body mb-10'>
                                <div className='accounts flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>Hosting Accounts</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>100</h2>
                                    </div>
                                </div>
                                <div className='storage flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>Storage</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>90GB</h2>
                                    </div>
                                </div>
                                <div className='domains flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>Domains</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>Unlimited</h2>
                                    </div>
                                </div>
                                <div className='bandwidth flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>Bandwidth</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>Unlimited</h2>
                                    </div>
                                </div>
                                <div className='sql flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>SQL Databases</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>Unlimited</h2>
                                    </div>
                                </div>
                                <div className='email flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>Email Addresses</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>Unlimited</h2>
                                    </div>
                                </div>
                                <div className='subdomains flex items-center'>
                                    <div>
                                        <h1 className='text-gray-300'>Subdomains</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>Unlimited</h2>
                                    </div>
                                </div>
                            </div>
                            <div className='footer'>
                                <div className='price mb-6'>
                                    <h1 className='text-gray-100 text-3xl font-semibold text-center'>$38.00 <span className='text-gray-300 text-sm font-normal'>/month</span></h1>
                                </div>
                                <div className='add-cart flex justify-center'>
                                    <Button title="Add to Cart" link="https://client.cyperhost.com/store/reseller-hosting/reseller-standard" />
                                </div>
                            </div>
                        </div>
                        <div className='plan bg-box py-12 px-10 rounded-lg'>
                            <div className='header mb-11'>
                                <h1 className='text-gray-100 font-semibold text-3xl text-center'>Enterprise</h1>
                            </div>
                            <div className='body mb-10'>
                                <div className='accounts flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>Hosting Accounts</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>150</h2>
                                    </div>
                                </div>
                                <div className='storage flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>Storage</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>150GB</h2>
                                    </div>
                                </div>
                                <div className='domains flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>Domains</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>Unlimited</h2>
                                    </div>
                                </div>
                                <div className='bandwidth flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>Bandwidth</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>Unlimited</h2>
                                    </div>
                                </div>
                                <div className='sql flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>SQL Databases</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>Unlimited</h2>
                                    </div>
                                </div>
                                <div className='email flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>Email Addresses</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>Unlimited</h2>
                                    </div>
                                </div>
                                <div className='subdomains flex items-center'>
                                    <div>
                                        <h1 className='text-gray-300'>Subdomains</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>Unlimited</h2>
                                    </div>
                                </div>
                            </div>
                            <div className='footer'>
                                <div className='price mb-6'>
                                    <h1 className='text-gray-100 text-3xl font-semibold text-center'>$55.00 <span className='text-gray-300 text-sm font-normal'>/month</span></h1>
                                </div>
                                <div className='add-cart flex justify-center'>
                                    <Button title="Add to Cart" link="https://client.cyperhost.com/store/reseller-hosting/reseller-enterprise" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='hardware py-28 max-w-7xl mx-auto px-5 sm:px-5 lg:px-5 py-5 pt-12 pb-24'>
                <div className="header mb-24">
                    <h1 className="text-gray-100 text-center text-3xl font-semibold mb-4">Top notch Hardware</h1>
                </div>
                <div className='body grid grid-cols-1 gap-y-16'>
                    <div className='ssd grid grid-cols-1 md:grid-cols-5 gap-5 items-center'>
                        <div className='col-span-1 md:col-span-2'>
                            <img src={SSD} alt="SSD" />
                        </div>
                        <div className='col-span-1 md:col-span-3'>
                            <h1 className='text-gray-100 text-2xl font-semibold mb-5'>Intel NVMe SSD drives</h1>
                            <p className='text-gray-300 text-lg'>Our cloud-focused Intel U.2 NVMe SSD drives offer the absolute fastest in server loading and response times.</p>
                        </div>
                    </div>
                    <div className='panel grid grid-cols-1 md:grid-cols-5 gap-5 items-center'>
                        <div className='col-span-1 md:col-span-3'>
                            <h1 className='text-gray-100 text-right text-2xl font-semibold mb-5'>Powerful Control Panel</h1>
                            <p className='text-gray-300 text-lg text-right'>Running the latest control panel for webhosting lets us be ahead of our competitors.</p>
                        </div>
                        <div className='col-span-1 md:col-span-2'>
                            <img src={Panel} alt="Panel" className='ml-auto' />
                        </div>
                    </div>
                </div>
            </section>
            <DDoSProtection />
            <WhyCyperhost />
            <Reviews />
            <Footer />
        </main>
    )
}

export default Web